import {
  parseDayMonthAndYear,
  parseYearMonthAndDay,
} from "@hopper-b2b/utilities";
import type { DateFormatter } from "../apac-form-ui/DateField/component";

const DATE_CONFIGS: Record<
  string,
  { format: string; formatter: DateFormatter }
> = {
  "fr-CA": {
    format: "YYYY-MM-DD",
    formatter: (date) => {
      const { year, month, day, strLength } = parseYearMonthAndDay(date);
      return (
        year +
        (strLength > 4 ? "-" : "") +
        month +
        (strLength > 6 ? "-" : "") +
        day
      );
    },
  },
  "en-CA": {
    format: "DD/MM/YYYY",
    formatter: (date) => {
      const { day, month, year, strLength } = parseDayMonthAndYear(date);
      return (
        day +
        (strLength > 2 ? "/" : "") +
        month +
        (strLength > 4 ? "/" : "") +
        year
      );
    },
  },
};

const DEFAULT_CONFIG = DATE_CONFIGS["en-CA"];

export function getLocalizedDateFormat(language: string): string {
  return (DATE_CONFIGS[language] ?? DEFAULT_CONFIG).format;
}

export function getLocalizedDateFormatter(language: string): DateFormatter {
  return (DATE_CONFIGS[language] ?? DEFAULT_CONFIG).formatter;
}
